import Test from "./Test";

export default class ActionSmokeTest extends Test {
  constructor(api) {
    super(api, "Actions Smoke Test");
  }

  async init() {
    try {
      // Fetch all workflows
      const response = await this.api.get("/workflow");
      let actions = [];
      for (let wf of response) {
        const actResp = await this.api.get("/action?workflow=" + wf.slug);
        for (let action of actResp) {
          if (action.items) {
            for (let item of action.items)
              actions.push({
                name: `Action Test: ${item.label || "[Unnamed]"}`,
                slug: item.slug,
                label: item.label,
                link:
                  this.api.host.replace("/api", "") + "/workflow/" + wf.slug,
                workflow: wf.slug
              });
            continue;
          }
          actions.push({
            name: `Action Test: ${action.label || "[Unnamed]"}`,
            slug: action.slug,
            label: action.label,
            link: this.api.host.replace("/api", "") + "/workflow/" + wf.slug,
            workflow: wf.slug
          });
        }
      }

      return actions;
    } catch (error) {
      // Handle error gracefully
      throw new Error("Failed to load workflows. Error: " + error.message);
    }
  }

  async exec(test) {
    let label = test.label || test.slug;
    // Fetch objects for the workflow
    let res = await this.api.get(`/workflow/${test.workflow}/objects`, {
      limit: 1,
      fields: "id"
    });
    if (res.error || !res.items || res.items.length === 0) {
      return {
        success: false,
        message: `Failed to load objects for workflow ${label}. Error: ${res?.error ? res?.error?.data?.message : "No Records Found"}`
      };
    }

    let id = res.items[0].items ? res.items[0].items[0].id : res.items[0].id;
    let ares = await this.api.get(
      `/action/${test.slug}/form?ids=${id}&skip_pv=true` //added skip_pre_validations to avoid pre-validation errors
    );

    if (ares.error)
      return {
        success: false,
        message: `Failed to load form for action ${label}. Error: ${ares?.error?.data?.message}`
      };
    else
      return {
        success: true,
        message: `Workflow ${label} passed successfully.`
      };

    // Handle error gracefully;
  }
}
